import {React, useState} from "react";
import Footer from "../../components/Footer_/Footer";
import AboutSec from "../../components/AboutSec_/AboutSec";
import CommonHero from "../../components/CommonHero_/CommonHero";
import Services from "../../components/Services_/Services";
import CallToAction from "../../components/CallToAction/CallToAction";
import HowItRunsSec from "../../components/HowItRunsSec/HowItRunsSec";
import InteractiveWalkthroughSec from "../../components/InteractiveWalkthroughSec/InteractiveWalkthroughSec";
import { Helmet } from "react-helmet";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import styles from "./ContactScreen.module.css";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";

const Commercial = () => {
   const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const history = useNavigate();

  const formSubmitHandler = (event) => {
    event.preventDefault();
    setLoading(true);
    axios
      .post("/send-contact-form", {
        name,
        email,
        phoneNumber: phoneNum,
        message,
      })
      .then((response) => {
        if (response.data.msg === "success") {
          setError(false);
          setSuccess("Form Submitted Successfully!");
          setLoading(false);
          setEmail("");
          history("/thank-you");
        } else if (response.data.msg === "fail") {
          setSuccess(false);
          setError("Email failed to send, try again by reloading the page.");
          setLoading(false);
          setEmail("");
        }
      });
  };
  return (
    <>
      <Helmet>
        <title>
          Commercial Site Power, Solar + Battery Storage | TRU Off Grid, Milton
        </title>
        <meta name="keywords" content="Batteries in Ontario" />
        <link rel="canonical" href="https://www.truoffgrid.com/commercial-solar-installation" />
        <meta
          name="description"
          content="Solar, battery and automatic generator systems for site offices, scale houses and job trailers, plus commercial solar and storage. Built in Milton, Ontario. Rent or own."
        />
      </Helmet>
      <CommonHero
        image={"/images/hero-commercial-new.jpg"}
        heading="TRU Off Grid Commercial"
      />
      <AboutSec
        heading={"POWER FOR JOB SITES AND BUSINESSES"}
        subHeading={"COMMERCIAL SOLAR, STORAGE AND SITE POWER"}
        text={`TRU Off Grid designs, builds and services solar, battery and backup generator systems for job sites and businesses across Ontario. Most
job sites still run a generator around the clock to power a small office. We flip that around: the battery runs the site, solar charges it, and
the generator only starts to recharge it.
<br></br>
Every system is built by our own crew, with a licensed master electrician on staff, ESA-permitted electrical work, and container builds
done at our Milton shop.
`}
        cta={false}
      />

 <AboutSec
        heading={"SITE OFFICE C-CAN"}
        subHeading={"OPTION 1"}
        text={`A complete off-grid office in a sea container: power system, workspace, heating and cooling in one
unit, delivered ready to use.
<br></br>
<ul>
<li>20 to 40 ft insulated sea container with finished walls</li>
<li>Mini-split heat pump for heating and cooling</li>
<li>Sub-panel and 120 V receptacles for laptops, printer, fridge and chargers</li>
<li>Built-in battery room, solar on the container, exterior generator inlet</li>
<li>Layout and system size set for each site</li>
</ul>
`}
        cta={false}
        img={"/images/section-site-office-c-can.jpg"}
        imgBorderRad={true}
      />
 <AboutSec
        heading={"POWER C-CAN"}
        subHeading={"OPTION 2"}
        text={`A mobile electrical room that powers the office trailers you already have, and moves with the project.
<br></br>
<ul>
<li>Spray-foam insulated container, climate controlled for the equipment</li>
<li>Batteries, inverters and controls built and tested at our Milton shop</li>
<li>One protected feeder out to each office trailer</li>
<li>Generator inlet and automatic generator start</li>
<li>Sized for 1 to 4 trailers, relocates between sites</li>
</ul>
`}
        cta={false}
        img={"/images/power-c-can-battery-room.jpg"}
        imgBorderRad={true}
        reverse={true}
      />
 <AboutSec
        heading={"TRAILER AND SCALE HOUSE RETROFITS"}
        subHeading={"OPTION 3"}
        text={`We install the system into your existing trailer or scale house: solar on the roof, the battery and inverter
inside.
<br></br>
<ul>
<li>Real result: an off-grid scale house on an aggregate site replaced a 12 kW diesel generator running 24/7</li>
<li>Rooftop solar, a 14.3 kWh battery, a 6 kW inverter and a 10.5 kW propane backup generator</li>
<li>March to April fuel: $300 to $390 of propane vs an estimated $3,170 to $4,700 of diesel</li>
<li>Roughly 90% lower fuel cost</li>
</ul>
`}
        cta={false}
        img={"/images/scale-house-rooftop-solar-retrofit.jpg"}
        imgBorderRad={true}
      />

       <AboutSec
        heading={"COMMERCIAL SOLAR + STORAGE"}
        subHeading={"FOR BUSINESSES"}
        text={`Roof and ground-mount solar with battery storage for shops, farms, warehouses and commercial
buildings, from small systems up to 180 kW.
<br></br>
<ul>
<li>Grid-tie net metering or load displacement</li>
<li>Battery backup for critical loads, from refrigeration to servers</li>
<li>Remote and pole-mount solar for off-grid equipment</li>
<li>Three-phase work and switchgear through TRU Electrical Services</li>

</ul>
`}
        cta={false}
        img={"/images/ground-mount-solar-array.jpg"}
        imgBorderRad={true}
        reverse={true}
      />

      <InteractiveWalkthroughSec
  subHeading="INTERACTIVE WALKTHROUGH"
  heading="SEE HOW A TRU SITE POWER SYSTEM WORKS"
  iframeSrc="/commercial-site-power-story.html"
/>

     <HowItRunsSec
  subHeading="HOW IT RUNS"
  heading="THE BATTERY RUNS THE SITE. THE GENERATOR ONLY RECHARGES IT."
  padding="60px 0"
  steps={[
    {
      number: "01",
      title: "SOLAR CHARGES",
      text: "Panels charge the battery and carry the load in daylight."
    },
    {
      number: "02",
      title: "BATTERY MODE",
      text: "Generator off. The site runs quietly on battery, overnight too."
    },
    {
      number: "03",
      title: "LOW BATTERY",
      text: "At about 10%, the generator starts on its own."
    },
    {
      number: "04",
      title: "RECHARGE",
      text: "The generator carries the load and refills the battery."
    },
    {
      number: "05",
      title: "CHARGED",
      text: "At about 95% the generator shuts off and the cycle repeats."
    }
  ]}
  options={[
    {
      title: "RENT",
      points: [
        "Monthly program, from a 6-month construction term to an annual program",
        "Delivery, hookup, commissioning and operator training",
        "Monitoring, maintenance and support included",
        "We pick it up when the project ends"
      ]
    },
    {
      title: "OWN",
      points: [
        "Buy the system as a company asset",
        "Move it from site to site as projects change",
        "Add batteries or inverters later without a redesign",
        "Built, commissioned and supported by the same TRU team"
      ]
    }
  ]}
  bottomNote="We have also built battery and solar power for asset tracking and disaster recovery, airline ground transport, forklifts, field engineering and testing, postal and courier fleets, conveyors, commercial scales, mining, and self-heating batteries for extreme cold."
/>

   <div
        style={{ padding: "80px 0px 80px 0px" }}
        className="main text-center"
      >
        <Container>
          <h2 className="h1_main pb-5">Gallery</h2>
          <Row className="gy-4">

             {Array.from({ length: 8 }, (_, i) => i + 1).map((num) => (
  <Col lg={6} key={num}>
    <img alt="gallery" style={{ width: "100%" }} src={`/images/gallery/commercial/gallery${num}.jpg`} />
  </Col>
))}
          </Row>
        </Container>
      </div>

       {/* <AboutSec
        heading={"Please Call "}
        headingSpan="905 462 6525"
        text={`The people who build your system are the people who answer the phone.`}
        img={"/images/commercial2.jpg"}
        reverse={true}
        imgBorderRad={true}
        cta6525={true}
      /> */}
  <AboutSec
        heading={"TELL US ABOUT YOUR"}
        headingSpan="SITE"
        text={`Send us your trailer count, a list of loads, the site location and your current fuel spend, and we will build a site-specific rent or own option. Call Jacob Collier at <a href="tel:647-914-9699">647-914-9699</a>, email <a href="mailto:jacob@truoffgrid.com">jacob@truoffgrid.com</a>, or call our main line at <a href="tel:905-462-6525">905-462-6525</a>.`}
        img={"/images/tru-team-at-the-milton-shop.jpg"}
        reverse={true}
        imgBorderRad={true}
        cta={false}
      />
   <div
        style={{ padding: "40px 0px 40px 0px" }}
        className="main text-center"
      >
        <Container>
          <Row className="gy-4 gx-5">
            <Col lg={6}>
              <div className={styles.contentCol}>
                <h3 className="h2_main pb-2">Contact us</h3>
                <h2 className="h1_main pb-4">
                  Need help with your solar project? <span>Lets Talk</span>
                </h2>
                <Row>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="tel:905-299-7841"
                    >
                      <div className={styles.info}>
                        <img src="/images/phone.svg" alt="icon" />
                        <p className="para_main">905-299-7841</p>
                      </div>
                    </a>
                  </Col>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="mailto: sales@truoffgrid.com"
                    >
                      <div className={styles.info}>
                        <img src="/images/mail.svg" alt="icon" />
                        <p className="para_main">sales@truoffgrid.com</p>
                      </div>
                    </a>
                  </Col>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      target="no_blank"
                      href="https://www.google.com/maps/dir//TRU+Off+Grid+-+Solar+%26+Energy+Storage,+348+Bronte+St.+S+Unit+21,+Milton,+ON+L9T+5B6/@43.5108146,-79.963851,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x267e0b12cb8a4ddf:0xae5c0834e6f5863a!2m2!1d-79.8791121!2d43.4996211?entry=ttu&g_ep=EgoyMDI2MTAxMy4wIKXMDSoASAFQAw%3D%3D"
                    >
                      <div className={styles.info}>
                        <img src="/images/location.svg" 
alt="icon"/>
                        <p className="para_main">
                          348 Bronte St., South Unit #21 Milton, ON (Please give
                          us a call, send an email or complete the Let's Get in
                          Touch form. Thanks)
                        </p>
                      </div>
                    </a>
                  </Col>
                </Row>
              </div>
            </Col>
            
            <Col lg={6}>
              <div className={styles.formCol}>
                <h2 className="h1_main pb-2">Let’s get in touch!</h2>
                <p className="para_main pb-5">
                  Lets discuss your project and find out what we can do
                </p>
                {loading ? (
                  <div className="row pb-4">
                    <div className="col-12">
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ color: "black" }}
                      />
                    </div>
                  </div>
                ) : success ? (
                  <div className="row pb-4">
                    <div className="col-12">
                      <p className="para_main" style={{ color: "black" }}>
                        {success}
                      </p>
                    </div>
                  </div>
                ) : (
                  error && (
                    <div className="row pb-4">
                      <div className="col-12">
                        <p className="para_main" style={{ color: "black" }}>
                          {error}
                        </p>
                      </div>
                    </div>
                  )
                )}
                <form onSubmit={formSubmitHandler}>
                  <input
                    maxLength="12"
                    type="text"
                    placeholder="Your Full Name"
                    pattern=".{3,}"
                    required
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                  <input
                    maxLength="36"
                    type="email"
                    placeholder="Email"
                    pattern=".{3,}"
                    required
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                  <input
                    maxLength="36"
                    type="text"
                    placeholder="Phone Number"
                    pattern=".{3,}"
                    required
                    value={phoneNum}
                    onChange={(event) => setPhoneNum(event.target.value)}
                  />
                  <input
                    style={{ resize: "none" }}
                    as="textarea"
                    maxLength="800"
                    type="text"
                    placeholder="Your Message"
                    required
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                  />
                  <button className="button_main mt-3" type="submit">
                    Submit
                  </button>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>


      {/* <CallToAction cta3={true} /> */}
      <div style={{ padding: "0px 0px 150px 0px" }}></div>
      <Footer newsletter={true} />
    </>
  );
};

export default Commercial;
